
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category/[category_id]",
      function () {
        return require("private-next-pages/category/[category_id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/category/[category_id]"])
      });
    }
  